// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import VirginIslandsUk from '../_raw/flag/icon_flag_virgin_islands_uk.png';

export default () => <img src={VirginIslandsUk} alt="VirginIslandsUk" />;
